<template>
  <div class="wrap white-bg mb40">

    <div class="apply-title">在线申请</div>
    <div class="apply-online">
      <el-form ref="applyFormRef" :model="applyForm" :rules="formRules">
        <div>
          <p class="apply-online-tit">公司信息</p>
          <el-form-item prop="company_name">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>公司名称</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.company_name" class="apply-txt" placeholder="请输入公司名称（必填）"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name">公司注册地址</p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.company_register_address" class="apply-txt"
                  placeholder="请如实填写详细地址，例如街道名称，门牌号，楼层和房间号等"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="main_bussiness">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>主营业务</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input type="textarea" v-model="applyForm.main_bussiness" placeholder="请输入主营业务（必填）"
                  class="apply-textarea"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="is_edu">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>是否有教育行业经验</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <div class="radio-content">
                  <el-radio-group v-model="applyForm.is_edu">
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="2">无</el-radio>
                  </el-radio-group>
                </div>

              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item prop="projectData">

            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>意向合作项目</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">

                <el-checkbox-group v-model="applyForm.projectData">
                  <el-row>
                    <el-col v-for="(item,index) in wdPproject" :md="6" :sm="6" :xs="8" :key="index">
                      <div class="checkbox-content">
                        <el-checkbox :label="item.value">{{item.name}}</el-checkbox>
                      </div>

                    </el-col>
                  </el-row>

                </el-checkbox-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="cityProData">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>意向城市</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">

                <el-cascader v-model="applyForm.cityProData" :props="{label:'name',value:'name'}" :options="cityList" placeholder="请选择意向城市">
                </el-cascader>

              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name">意向城市教育市场概括及分析</p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input type="textarea" v-model="applyForm.intentional_maket_analytical" placeholder="请详细描述市场情况"
                  class="apply-textarea"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

        </div>
        <div>
          <p class="apply-online-tit">联系人信息</p>
          <el-form-item prop="name">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>姓名</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.name" class="apply-txt" placeholder="请填写真实姓名（必填）"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="phone">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>手机号码</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.phone" class="apply-txt" placeholder="申请过程中用于接收审核结果，请务必仔细确认（必填）">
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="phoneCode">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>验证码</span></p>
              </el-col>
              <el-col :md="14" :sm="13" :xs="16">
                <el-input v-model="applyForm.phoneCode" class="apply-txt" placeholder="请输入手机验证码"></el-input>
              </el-col>
              <el-col :md="3" :sm="4" :xs="7" :offset="1">
                <el-button :class="['get-code-btn', btnDisabled?'btn-disbled':'']" type="primary" @click="getCodeFun"
                  :disabled="btnDisabled">{{btnTxt}}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name">地址</p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input type="textarea" v-model="applyForm.address" placeholder="请如实填写详细地址，例如街道名称，门牌号，楼层和房间号等"
                  class="apply-textarea"></el-input>

              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name">从何处获取信息</p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.from_where" class="apply-txt" placeholder></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="is_abut">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>对接招商人员</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <div class="radio-content">
                  <el-radio-group v-model="applyForm.is_abut">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="2">无</el-radio>
                  </el-radio-group>
                </div>

              </el-col>
            </el-row>

          </el-form-item>
          <el-form-item prop="merchants_name" v-if="applyForm.is_abut=='1'">
            <el-row class="form-list">
              <el-col :md="6" :sm="6" :xs="24">
                <p class="label-name"><span>招商人员</span></p>
              </el-col>
              <el-col :md="18" :sm="18" :xs="24">
                <el-input v-model="applyForm.merchants_name" class="apply-txt" placeholder="请填写招商人员姓名"></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-row>
            <el-col :md="18" :sm="18" :xs="24" :offset="6">
              <el-button type="primary" @click="submitForm()">提交</el-button>
            </el-col>
          </el-row>
        </div>

      </el-form>

    </div>

    <!-- 提交弹窗 -->
    <div class="submit-pop" v-if="popupShow==1">
      <div class="popup-content">
        <div class=""><img class="popup-icon" src="@/assets/images/icon/ic_success.png" alt=""></div>
        <p class="popup-title">提交成功</p>
        <p class="popup-detail">恭喜您提交成功，期待我们精诚合作。</p>
        <div>
          <router-link class="to-home" :to="{path:'/'}">返回首页</router-link>
        </div>

      </div>
    </div>
    <!-- 提交事变 -->
    <div class="submit-pop" v-if="popupShow==2">
      <div class="popup-content">
        <div class="clearfix">
          <img class="popup-icon" src="@/assets/images/icon/ic_error.png" alt="">
        </div>
        <div class="popup-title">提交失败</div>
        <div class="popup-detail">请您拨打合作热线 15600128367</div>
        <img src="@/assets/images/icon/close.png" alt="" class="close-btn" @click="closeFun">
      </div>
    </div>

  </div>
  <!-- form end  -->
</template>

<script >
import { defineComponent, ref, reactive } from "vue";
import { cityList } from "./city.js";
import qs from "qs";
// import axios from "axios";
import axios from "@/axios/index.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  setup(props) {
    const applyFormRef = ref(); //dom
    let count = ref(60); // 倒计时
    let btnDisabled = ref(false); //获取验证码禁用
    let btnTxt = ref("获取验证码"); // 获取验证码文字
    let popupShow = ref(0); //弹窗显示与否

    // 意向合作项目
    const wdPproject = reactive([
      {
        value: "1",
        name: "考研、四六级"
      },
      {
        value: "2",
        name: "公务员"
      },
      {
        value: "3",
        name: "教师资格"
      },
      {
        value: "4",
        name: "教师招聘"
      },
      {
        value: "5",
        name: "特岗教师"
      },
      {
        value: "6",
        name: "医师资格"
      },
      {
        value: "7",
        name: "执业药师"
      },
      {
        value: "8",
        name: "护士执业"
      },
      {
        value: "9",
        name: "卫生职称"
      },
      {
        value: "10",
        name: "法考"
      },
      {
        value: "11",
        name: "一级建造师"
      },
      {
        value: "12",
        name: "二级建造师"
      },
      {
        value: "13",
        name: "造价工程师"
      },
      {
        value: "14",
        name: "消防工程师"
      }
    ]);
    let applyForm = ref({
      company_name: "", //公司名称
      company_register_address: "", //公司地址
      main_bussiness: "", //主营业务
      is_edu: "", //是否有经验
      intentional_cooperation_project: "", //意向合作项目
      intentional_city: "", // 意向合作城市
      intentional_maket_analytical: "", //意向城市教育市场概括及分析
      name: "", // 姓名
      phone: "", //手机号
      from_where: "", //从何处获取信息
      is_abut: "", //对接招商人员（1-有 2-无）
      merchants_name: "", //招商人员姓名
      address: "", //地址
      phoneCode: "",
      projectData: [],
      cityProData: []
    });
    // 验证手机号
    const checkMobile = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback(); //必须调用，参数为空视为校验通过
    };
    // 招商人员校验
    const checkMerchants = (rule, value, callback) => {
      if (applyForm.value.is_abut == "1" && value == "") {
        callback(new Error("请输入招商人员姓名"));
      }
      callback();
    };
    const formRules = reactive({
      company_name: [
        //公司姓名
        { required: true, message: "请输入公司名称", trigger: "blur" }
      ],
      main_bussiness: [
        //主营业务
        { required: true, message: "请输入主营业务", trigger: "blur" }
      ],
      is_edu: [
        // 是否有教育行业经验
        {
          required: true,
          message: "请选择是否有教育行业经验",
          trigger: "change"
        }
      ],
      intentional_cooperation_project: [
        { required: true, message: "请选择意向合作项目", trigger: "change" }
      ],
      projectData: [
        { required: true, message: "请选择意向合作项目", trigger: "change" }
      ],
      //意向城市

      cityProData: [
        { required: true, message: "请选择意向城市", trigger: "change" }
      ],
      name: [{ required: true, message: "请填写真实姓名", trigger: "blur" }],
      phone: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          validator: checkMobile,
          trigger: "blur",
          message: ""
        }
      ],
      is_abut: [
        { required: true, message: "请选择是否有对接招商人员", trigger: "blur" }
      ],
      merchants_name: [
        {
          validator: checkMerchants,
          trigger: "blur"
        }
      ],
      phoneCode: [{ required: true, message: "请填写验证码", trigger: "blur" }]
    });

    // 获取手机验证码
    const getCodeFun = () => {
      applyFormRef.value.validateField("phone", errorMessage => {
        if (errorMessage) {return};
        let params = {
          mobile: applyForm.value.phone
        };
        countDownFun();
        axios.post("/mobile/sendcode", qs.stringify(params)).then(res => {
          if (res.data.code == 200) {
            
          } else {
            ElMessage.error("获取验证码失败，请重新获取");
          }
        });
      });
    };
    // 倒计时
    const countDownFun = () => {
      let timer = setInterval(() => {
        count.value = count.value - 1;
        btnTxt.value = count.value + "S后重新获取";
        btnDisabled.value = true;
        if (count.value == 0) {
          clearInterval(timer);
          count.value = 60;
          btnTxt.value = "获取验证码";
          btnDisabled.value = false;
        }
      }, 1000);
    };
    // 提交
    const submitForm = () => {
      applyFormRef.value.validate(valid => {
        if (valid) {
          //校验手机号验证码
          let phoneParams = {
            mobile: applyForm.value.phone,
            smsCode: applyForm.value.phoneCode
          };

          // 提交参数
          let params = {
            company_name: applyForm.value.company_name, //公司名称
            company_register_address: applyForm.value.company_register_address, //公司地址
            main_bussiness: applyForm.value.main_bussiness, //主营业务
            is_edu: applyForm.value.is_edu, //是否有经验
            intentional_cooperation_project: applyForm.value.projectData.toString(), //意向合作项目
            intentional_city: applyForm.value.cityProData.join(","), // 意向合作城市
            intentional_maket_analytical: applyForm.value.intentional_maket_analytical, //意向城市教育市场概括及分析
            name: applyForm.value.name, // 姓名
            phone: applyForm.value.phone, //手机号
            from_where: applyForm.value.from_where, //从何处获取信息
            is_abut: applyForm.value.is_abut, //对接招商人员（1-有 2-无）
            merchants_name: applyForm.value.merchants_name, //招商人员姓名
            address: applyForm.value.address //地址
          };
          axios.post("/mobile/checkvalidatecode", qs.stringify(phoneParams))
            .then(res => {
              if (res.data.code == 200) {
                //校验通过 提交
                axios.post("/zhaoshang/website/submitcontact",qs.stringify(params))
                  .then(res => {
                    if (res.data.code == 200) {
                      popupShow.value = 1; //提交成功
                      formReset();
                        setTimeout(() => {
                            popupShow.value = 0;
                        }, 3000);
                    } else {
                      popupShow.value = 2; //提交失败
                    }
                    
                  });
              } else {
                ElMessage.error(res.data.msg);
              }
            });
        }
      });
    };

    // 清空
    const formReset = () => {
      applyForm.value = {
        company_name: "", //公司名称
        company_register_address: "", //公司地址
        main_bussiness: "", //主营业务
        is_edu: "", //是否有经验
        intentional_cooperation_project: "", //意向合作项目
        intentional_city: "", // 意向合作城市
        intentional_maket_analytical: "", //意向城市教育市场概括及分析
        name: "", // 姓名
        phone: "", //手机号
        from_where: "", //从何处获取信息
        is_abut: "", //对接招商人员（1-有 2-无）
        merchants_name: "", //招商人员姓名
        address: "", //地址
        phoneCode: "",
        projectData: [],
        cityProData: []
      };
    };

    const closeFun=()=>{
        popupShow.value=0
    }
    return {
      cityList,
      applyFormRef,
      wdPproject,
      applyForm,
      formRules,
      submitForm,
      checkMobile,
      getCodeFun,
      count,
      btnDisabled,
      btnTxt,
      checkMerchants,
      popupShow,
      formReset,
      closeFun
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.apply-online {
  padding: 0 80px 80px;
  .apply-online-tit {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #e9f0f6;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 32px;
  }
  .label-name {
    padding-right: 40px;
    text-align: right;
    line-height: 40px;
    span {
      position: relative;
      float: right;
      &:before {
        position: absolute;
        left: -9px;
        top: 0px;
        content: "*";
        color: #ff5c5c;
        padding-right: 3px;
        line-height: 45px;
      }
    }
  }
  .apply-txt {
    .el-input__inner {
      height: 40px;
      border: 1px solid #e9f0f6;
      border-radius: 0;
    }
  }
  .apply-textarea {
    .el-textarea__inner {
      height: 120px;
      border: 1px solid #e9f0f6;
      border-radius: 0;
    }
  }

  /*radio/checkbox*/
  .el-radio__inner,
  .el-checkbox__inner {
    width: 16px !important;
    height: 16px !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
  .radio-content,
  .checkbox-content {
    height: 40px;
    line-height: 40px;
  }

  /* button */
  .el-button--primary {
    width: 120px;
    height: 40px;
    background: #0099ff;
    border-radius: 0;
    font-size: 14px;
  }
  .get-code-btn {
    width: 100%;
    padding: 0;
  }
  .btn-disbled {
    background: #1b1d1f;
    border: 1px solid #1b1d1f;
    // color:#333;
    opacity: 0.3;
  }
  /deep/ .el-form-item {
    margin-bottom: 32px;
  }
  //错误提示信息
  /deep/ .el-form-item__error {
    left: 25%;
    color: #ff5c5c;
  }
  /deep/ .el-cascader {
    width: 100%;
  }
}

.submit-pop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  .popup-content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 480px;
    padding: 40px 0;
    transform: translate(-50%, -50%);
    background: #fff;
    text-align: center;
    border-radius: 8px;
  }
  .close-btn{
      position:absolute;
      right:20px;
      top:20px;
      width:10px;
      height:10px;
      cursor: pointer;
  }
  .popup-icon {
    display: block;
    width: 48px;
    height: 48px;
    margin: 0 auto 24px;
  }
  .popup-title {
    font-size: 16px;
    color: #1b1d1f;
    margin-bottom: 8px;
  }
  .popup-content {
    font-size: 14px;
    color: #869099;
  }
  .to-home {
    display: block;
    width: 88px;
    height: 32px;
    background: #0099ff;
    border-radius: 16px;
    color: #fff;
    line-height: 32px;
    margin: 40px auto 0;
  }
}
.popup-fail {
  .popup-content {
    height: 200px;
  }
}
@media screen and(max-width:767px) {
  .apply-online {
    .label-name {
      text-align: left;
      span {
        float: left;
        text-align: left;
      }
    }
    /deep/ .el-form-item__error {
      left: 0;
    }
  }
}
</style>
